import api from './api';

export const getMaterialsStock = () => api.get('/materials-stock');
export const getMaterialsList = () => api.get('/materials-stock/materials-list');
export const createOrUpdateMaterialStock = (data) => api.post('/materials-stock', data);
export const updateMaterialStock = (id, data) => api.put(`/materials-stock/${id}`, data);
export const deleteMaterialStock = (id) => api.delete(`/materials-stock/${id}`);
export const bulkUpdateMaterialsStock = (data) => api.post('/materials-stock/bulk-update', data);
